import { render, staticRenderFns } from "./DataRenderer.vue?vue&type=template&id=00313d5e&scoped=true"
import script from "./DataRenderer.vue?vue&type=script&lang=js"
export * from "./DataRenderer.vue?vue&type=script&lang=js"
import style0 from "./DataRenderer.vue?vue&type=style&index=0&id=00313d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00313d5e",
  null
  
)

export default component.exports